export const getFileName = (data: string) => {
    if (data) {
        const parts = data.split('/');
        const lastSegment = parts.pop() || parts.pop();

        return lastSegment;
    }   
}